import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useLoading } from "../contexts/LoadingContext";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./loader.css";

const Loader = ({ type = "doctor", count = 3 }) => {
  if (type === "package") {
    return (
      <div className="loader-content">
        <Container fluid>
          <Row className="package-list">
            {[1, 2].map((item) => (
              <Col key={item} xs={12} md={4} className="mb-4">
                <Card className="h-100 package-card">
                  <div className="ribbon">
                    <Skeleton height={24} width={80} />
                  </div>
                  <Card.Body>
                    <div className="text-center mb-3">
                      <Skeleton height={28} width="80%" className="mb-3" />
                      <div className="price">
                        <Skeleton height={20} width="40%" className="mb-2" />
                        <Skeleton height={24} width="60%" className="mb-2" />
                      </div>
                    </div>
                    <ul className="features-list">
                      {[1, 2, 3, 4, 5].map((feature) => (
                        <li key={feature} className="feature-item">
                          <Skeleton height={20} width="90%" className="mb-2" />
                        </li>
                      ))}
                    </ul>
                    <div className="mt-4">
                      <Skeleton height={40} width="100%" className="mb-2" />
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    );
  }

  const renderDoctorCardSkeleton = () => (
    <Row className="mt-4">
      {[...Array(count)].map((_, index) => (
        <Col key={index} xs={12} md={6} lg={6} className="mb-4">
          <Card className="h-100">
            <Card.Body>
              <Row>
                <Col md={12} lg={6} className="d-flex justify-content-center">
                  <Skeleton circle height={150} width={150} />
                </Col>
                <Col md={12} lg={6}>
                  <Skeleton height={20} width="80%" className="mb-2" />
                  <Skeleton height={15} width="60%" className="mb-2" />
                  <Skeleton height={15} width="40%" className="mb-2" />
                  <div className="mt-3">
                    <Skeleton height={35} width={100} />
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );

  const renderPreviousAndUpcoming = () => (
    <Row className="mt-4">
      {[...Array(count)].map((_, index) => (
        <Col key={index} xs={12} md={6} lg={4} className="mb-4">
          <Card className="h-100">
            <Card.Body>
              <Row>
                <Col xs={4}>
                  <Skeleton circle height={80} width={80} />
                </Col>
                <Col xs={8}>
                  <Skeleton height={20} width="80%" className="mb-2" />
                  <Skeleton height={15} width="60%" className="mb-2" />
                  <Skeleton height={15} width="40%" className="mb-2" />
                  <div className="mt-3">
                    <Skeleton height={35} width={100} />
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );

  const renderDoctorProfileSkeleton = () => (
    <Row className="justify-content-center">
      <Col md={8} lg={7}>
        <Card className="shadow-lg border-0 rounded">
          <Card.Header className="text-center">
            <Skeleton
              circle
              height={150}
              width={150}
              className="mx-auto mb-3"
            />
            <Skeleton height={30} width="60%" className="mx-auto mb-2" />
            <Skeleton height={20} width="40%" className="mx-auto mb-3" />
            <Skeleton height={40} width="20%" className="mx-auto" />
          </Card.Header>
          <Card.Body>
            <Skeleton height={20} width="90%" className="mb-3" />
            <Skeleton height={20} width="80%" className="mb-3" />
            <Skeleton height={20} width="85%" className="mb-3" />
            <Skeleton height={100} width="100%" className="mb-3" />
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );

  const renderPrescriptionSkeleton = () => (
    <Row className="mt-4">
      {[...Array(count)].map((_, index) => (
        <Col key={index} xs={12} md={6} lg={4} className="mb-4">
          <Card className="prescription-card">
            <Card.Body>
              <Row>
                <Col xs={6} md={4} lg={4}>
                  <div className="flex flex-column align-items-center  mb-2">
                    <Skeleton circle height={80} width={80} className="me-2" />
                    <Skeleton height={20} width="60%" />
                  </div>
                </Col>
                <Col xs={6} md={8} lg={8}>
                  <Skeleton height={20} width="90%" className="mb-2" />
                  <Skeleton height={15} width="70%" className="mb-2" />
                  <div className="mt-2">
                    <Skeleton height={15} width="60%" />
                  </div>
                  <div className="text-start mt-3">
                    <Skeleton height={30} width={100} />
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );

  const renderAppointmentSkeleton = () => (
    <Row>
      {[...Array(count)].map((_, index) => (
        <Col key={index} xs={12} className="mb-4">
          <Card>
            <Card.Body>
              <Row>
                <Col md={12} className="mb-3">
                  <Skeleton height={40} width="100%" className="mb-3" />
                  <Row>
                    {[...Array(7)].map((_, index) => (
                      <Col key={index} md={1}>
                        <Skeleton height={60} width="100%" />
                      </Col>
                    ))}
                  </Row>
                </Col>
                <Col md={12}>
                  <Row>
                    {[...Array(8)].map((_, index) => (
                      <Col key={index} md={3} className="mb-3">
                        <Skeleton height={40} width="100%" />
                      </Col>
                    ))}
                  </Row>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );

  if (type === "selectedappointment") {
    return (
      <div className="day-scrolling-calendar">
        <Card className="shadow-lg border-0 rounded mb-3">
          <div className="d-flex align-items-center">
            <Col
              md={5}
              lg={3}
              sm={12}
              xs={5}
              className="text-center mb-4 mb-md-0"
            >
              <Skeleton circle height={70} width={70} />
            </Col>
            <Col md={7} sm={12} xs={7} className="text-left mt-md-2">
              <Row>
                <Skeleton height={24} width={200} />
              </Row>
              <Row className="mt-2">
                <Skeleton height={20} width={150} />
              </Row>
              <Card.Body>
                <Skeleton count={3} height={20} className="mb-2" />
              </Card.Body>
            </Col>
          </div>
        </Card>

        {/* Calendar Day Picker Skeleton */}
        <div className="mt-4">
          <div className="days-list d-flex gap-2 overflow-hidden">
            {[...Array(7)].map((_, idx) => (
              <Skeleton key={idx} height={40} width={100} />
            ))}
          </div>
        </div>

        {/* Time Slots Skeleton */}
        <div className="time-slots-container mt-4">
          <Skeleton height={30} width={300} className="mb-4" />
          <Row>
            {[...Array(8)].map((_, idx) => (
              <Col key={idx} xs={3} className="mb-3">
                <Skeleton height={40} width="90%" />
              </Col>
            ))}
          </Row>
        </div>
      </div>
    );
  }

  return (
    <div className="loader-content">
      <Container fluid>
        {type === "doctor" && renderDoctorCardSkeleton()}
        {type === "upcoming-previous" && renderPreviousAndUpcoming()}
        {type === "doctorProfile" && renderDoctorProfileSkeleton()}
        {type === "prescription" && renderPrescriptionSkeleton()}
        {type === "appointment" && renderAppointmentSkeleton()}
      </Container>
    </div>
  );
};

export default Loader;
